import { Outlet, Navigate } from 'react-router-dom';

export default function UserProtectedRoutes ({ userName }) {    
    if (!userName) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;    
}
